import { SVGProps } from 'react'

export const ClusterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="24"
    viewBox="0 0 19 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.49951 15C6.15637 15 7.49951 13.6569 7.49951 12C7.49951 10.3432 6.15637 9.00002 4.49951 9.00002M4.49951 15C3.77979 15 3.11927 14.7466 2.60232 14.3241C1.92921 13.7739 1.49951 12.9372 1.49951 12C1.49951 11.3118 1.73127 10.6777 2.12101 10.1715C2.26195 9.9884 2.42355 9.82207 2.60232 9.67596C3.11927 9.25346 3.77979 9.00002 4.49951 9.00002M4.49951 15V18.2869M4.49951 9.00002V5.89783M7.08951 13.51L12.9195 17.49M12.9095 6.51002L7.08951 10.49M4.49951 5.89783C5.63577 5.78128 6.52212 4.82123 6.52212 3.65418C6.52212 2.40851 5.51231 1.39869 4.26663 1.39869C3.02096 1.39869 2.01114 2.40851 2.01114 3.65418C2.01114 4.89986 3.02097 5.9097 4.26664 5.9097C4.34527 5.9097 4.42296 5.90568 4.49951 5.89783ZM4.49951 18.2869C4.42296 18.279 4.34527 18.275 4.26664 18.275C3.02097 18.275 2.01115 19.2848 2.01115 20.5305C2.01115 21.7762 3.02097 22.786 4.26664 22.786C5.51232 22.786 6.52214 21.7762 6.52214 20.5305C6.52214 19.3634 5.63577 18.4034 4.49951 18.2869ZM17.4995 5.00002C17.4995 5.65687 16.1564 7.00002 15.4995 7.00002C14.8427 7.00002 13.4995 5.65687 13.4995 5.00002C13.4995 4.34316 14.8427 3.00002 15.4995 3.00002C16.1564 3.00002 17.4995 4.34316 17.4995 5.00002ZM17.4995 19C17.4995 20.6569 17.1564 21 15.4995 21C13.8427 21 13.4995 20.6569 13.4995 19C13.4995 17.3431 13.8427 17 15.4995 17C17.1564 17 17.4995 17.3431 17.4995 19Z"
      stroke="#475467"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
